import React, {
  useState,
  useEffect,
} from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  TextField,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import VisibilityIcon from "@material-ui/icons/Visibility";
import ReceiptIcon from "@material-ui/icons/Receipt";
import ImageIcon from "@material-ui/icons/Image";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },

  card: {
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    boxShadow: "none",
    overflow: "hidden",
    backgroundColor: "#fff",
  },

  sectionHeader: {
    padding: theme.spacing(2.25, 2.5),
    backgroundColor: "#fafafa",
  },

  sectionTitle: {
    fontWeight: 600,
    color: "#1f2937",
  },

  sectionSubtitle: {
    marginTop: 3,
    color: "#6b7280",
  },

  headerIcon: {
    width: 38,
    height: 38,
    minWidth: 38,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#eef2ff",
    color: theme.palette.primary.main,
    marginRight: 12,
  },

  content: {
    padding: theme.spacing(2.5),
  },

  field: {
    marginBottom: theme.spacing(2),

    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  photoCard: {
    width: "100%",
    minHeight: 420,
    borderRadius: 10,
    backgroundColor: "#f8fafc",
    border: "1px solid #e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },

  photo: {
    width: "100%",
    height: 420,
    objectFit: "contain",
    display: "block",
  },

  emptyPhoto: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#9ca3af",
    textAlign: "center",
    padding: theme.spacing(3),
  },

  emptyPhotoIcon: {
    fontSize: 46,
    marginBottom: theme.spacing(1),
    color: "#cbd5e1",
  },

  fileInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },

  summaryBox: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.75),
    borderRadius: 10,
    border: "1px solid #e5e7eb",
    backgroundColor: "#f8fafc",
  },

  summaryTitle: {
    fontWeight: 600,
    color: "#374151",
    marginBottom: theme.spacing(1),
  },

  summaryRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 0",
  },

  summaryLabel: {
    color: "#6b7280",
    fontSize: 13,
  },

  summaryValue: {
    color: "#111827",
    fontSize: 13,
    fontWeight: 600,
  },

  totalRow: {
    borderTop: "1px solid #d1d5db",
    marginTop: 8,
    paddingTop: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  totalLabel: {
    color: "#111827",
    fontSize: 14,
    fontWeight: 700,
  },

  totalValue: {
    color: "#111827",
    fontSize: 16,
    fontWeight: 700,
  },

  actionSection: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(2),
  },

  actionButton: {
    minHeight: 42,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    paddingLeft: 18,
    paddingRight: 18,
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const Views = () => {
  const classes = useStyles();

  const [year, setYear] = useState("");
  const [loading, setLoading] = useState(false);

  const [discount, setDiscount] = useState(0);
  const [price, setPrice] = useState("");
  const [amount, setAmount] = useState(0);

  const [firstname, setFirstName] = useState("");
  const [artist, setArtist] = useState("");
  const [title, setTitle] = useState("");
  const [medium, setMedium] = useState("");
  const [size, setSize] = useState("");
  const [type, setType] = useState("Private Sale");

  const [imageData, setImageData] = useState("");
  const [imageData1, setImageData1] = useState("");

  const [date, setDate] = useState("");

  // =========================
  // IMAGE CHANGE
  // =========================

  const handleImageChange = (event) => {
    const selectedFile =
      event.target.files &&
      event.target.files[0];

    if (!selectedFile) {
      return;
    }

    setImageData1(selectedFile);

    const reader = new FileReader();

    reader.onload = (readerEvent) => {
      setImageData(readerEvent.target.result);
    };

    reader.readAsDataURL(selectedFile);
  };

  // =========================
  // FORMAT MONEY
  // =========================

  const formatMoney = (value) => {
    return parseFloat(value || 0).toLocaleString(
      undefined,
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }
    );
  };

  // =========================
  // ESCAPE HTML
  // =========================

  const escapeHtml = (value) => {
    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  // =========================
  // GENERATE PREVIEW
  // =========================

  const generatePDF = () => {
    setLoading(true);

    try {
      const formattedDate = date
        ? new Date(date).toLocaleDateString(
            "en-US",
            {
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          )
        : "";

      const finalAmount =
        parseFloat(amount || 0) -
        parseFloat(discount || 0);

      const imageHtml = imageData
        ? `
            <img
              src="${escapeHtml(imageData)}"
              alt="Artwork"
              class="artwork-image"
            />
          `
        : `
            <div class="no-image">
              No Image
            </div>
          `;

      // Open new tab
      const printWindow = window.open(
        "",
        "_blank",
        "width=1100,height=900"
      );

      if (!printWindow) {
        setLoading(false);
        alert(
          "Please allow pop-ups for this website."
        );
        return;
      }

      // =========================
      // HTML PRINT PREVIEW
      // =========================

      printWindow.document.open();

      printWindow.document.write(`
        <!DOCTYPE html>

        <html>

          <head>

            <meta charset="UTF-8" />

            <title>
              Private Sale Receipt
            </title>

            <style>

              @page {
                size: A4 portrait;
                margin: 0;
              }

              * {
                box-sizing: border-box;
              }

              html,
              body {
                margin: 0;
                padding: 0;
                background: #e5e7eb;
                color: #000;
              }

              body {
                font-family:
                  Arial,
                  Helvetica,
                  sans-serif;

                padding-bottom: 40px;
              }

              /* =====================
                 TOP BAR
              ===================== */

              .topbar {
                position: sticky;
                top: 0;
                z-index: 1000;

                height: 60px;
                width: 100%;

                background: #ffffff;

                border-bottom:
                  1px solid #d1d5db;

                box-shadow:
                  0 2px 8px
                  rgba(0, 0, 0, 0.08);

                display: flex;
                align-items: center;
                justify-content: flex-end;

                padding: 0 20px;
              }

              .print-button {
                border: none;

                background: #1976d2;
                color: #ffffff;

                padding: 10px 18px;

                border-radius: 6px;

                font-family:
                  Arial,
                  sans-serif;

                font-size: 14px;
                font-weight: 600;

                cursor: pointer;
              }

              .print-button:hover {
                background: #1565c0;
              }

              /* =====================
                 PAPER
              ===================== */

              .paper {
                width: 210mm;
                min-height: 297mm;

                margin: 25px auto;

                padding: 18mm;

                background: #ffffff;

                box-shadow:
                  0 5px 25px
                  rgba(0, 0, 0, 0.15);
              }

              /* =====================
                 EDITABLE
              ===================== */

              .editable {
                outline: none;
                cursor: text;
                border-radius: 2px;
                transition: background 0.15s ease;
              }

              .editable:hover {
                background: #fffde7;
              }

              .editable:focus {
                background: #fff8cc;

                box-shadow:
                  inset 0 0 0 1px
                  #d6b656;
              }

              /* =====================
                 HEADER
              ===================== */

              .header {
                display: flex;

                align-items:
                  flex-start;

                justify-content:
                  space-between;

                padding-bottom: 12px;

                border-bottom:
                  1px solid #000;
              }

              .logo {
                width: 180px;
                height: auto;
                object-fit: contain;
              }

              .contact {
                text-align: right;
                font-size: 10px;
                line-height: 1.5;
              }

              .contact p {
                margin: 0;
              }

              /* =====================
                 TITLE
              ===================== */

              .document-title {
                text-align: center;

                font-size: 19px;
                font-weight: 700;

                margin: 23px 0 20px;

                text-transform:
                  uppercase;
              }

              /* =====================
                 INFO
              ===================== */

              .info {
                margin-bottom: 18px;
              }

              .info-row {
                display: flex;

                margin-bottom: 6px;

                font-size: 12px;
              }

              .info-label {
                width: 80px;
                font-weight: 700;
              }

              .info-value {
                flex: 1;
                min-height: 18px;
              }

              /* =====================
                 TABLE
              ===================== */

              .receipt-table {
                width: 100%;

                border-collapse:
                  collapse;

                border:
                  0.5pt solid #000;
              }

              .receipt-table th {
                background: #f2f2f2;

                border:
                  0.5pt solid #000;

                padding: 8px;

                font-size: 10px;
                font-weight: 700;

                text-transform:
                  uppercase;

                text-align: center;
              }

              .receipt-table td {
                border:
                  0.5pt solid #000;

                padding: 8px;

                vertical-align: top;

                page-break-inside:
                  avoid;
              }

              .artist-cell {
                width: 20%;
                text-align: center;
                font-size: 11px;
              }

              .details-cell {
                width: 55%;
                text-align: center;
              }

              .amount-cell {
                width: 25%;
                text-align: center;
                font-size: 11px;
                font-weight: 600;
              }

              /* =====================
                 IMAGE
              ===================== */

              .artwork-image {
                width: 100%;
                height: 300px;

                object-fit: contain;

                display: block;

                margin: 0 auto;
              }

              .no-image {
                width: 100%;
                height: 300px;

                display: flex;

                align-items: center;
                justify-content: center;

                background: #f5f5f5;

                color: #777;

                font-size: 11px;
              }

              .artwork-details {
                margin-top: 10px;

                font-size: 11px;
                line-height: 1.7;
              }

              .artwork-title {
                font-size: 14px;
                font-weight: 600;

                margin-bottom: 4px;
              }

              .artwork-type {
                font-size: 11px;
              }

              .amount-section {
                display: flex;

                justify-content:
                  space-between;

                align-items: center;

                font-size: 12px;
              }

              .subtotal-label {
                font-weight: 700;
              }

              /* =====================
                 SUMMARY
              ===================== */

              .summary-label {
                border:
                  0.5pt solid #000;

                padding: 8px;

                text-align: right;

                font-size: 10px;
                font-weight: 600;

                text-transform:
                  uppercase;
              }

              .summary-value {
                border:
                  0.5pt solid #000;

                padding: 8px;

                text-align: center;

                font-size: 11px;

                min-height: 18px;
              }

              .total-label {
                border:
                  0.5pt solid #000;

                padding: 10px 8px;

                text-align: right;

                font-size: 11px;
                font-weight: 700;

                text-transform:
                  uppercase;
              }

              .total-value {
                border:
                  0.5pt solid #000;

                padding: 10px 8px;

                text-align: center;

                font-size: 12px;
                font-weight: 700;

                background: #f9f9f9;

                min-height: 20px;
              }

              /* =====================
                 SIGNATURE
              ===================== */

              .signature-section {
                margin-top: 75px;

                display: flex;

                justify-content:
                  flex-end;

                page-break-inside:
                  avoid;
              }

              .signature {
                width: 220px;
                text-align: center;
              }

              .signature-space {
                min-height: 25px;
                margin-bottom: 5px;
              }

              .signature-line {
                border-top:
                  0.5pt solid #000;

                padding-top: 5px;

                font-size: 11px;
                font-weight: 700;

                text-transform:
                  uppercase;
              }

              /* =====================
                 ADDRESS
              ===================== */

              .address {
                text-align: center;

                margin-top: 50px;

                font-size: 10px;

                line-height: 1.5;
              }

              .address p {
                margin: 2px 0;
              }

              /* =====================
                 PRINT
              ===================== */

              @media print {

                html,
                body {
                  background: #ffffff;
                }

                body {
                  padding: 0;
                }

                .topbar {
                  display:
                    none !important;
                }

                .paper {
                  width: 210mm;
                  min-height: 297mm;

                  margin: 0;

                  padding: 18mm;

                  box-shadow: none;
                }

                .editable:hover,
                .editable:focus {
                  background:
                    transparent !important;

                  box-shadow:
                    none !important;
                }

                .receipt-table tr,
                .signature-section {
                  page-break-inside:
                    avoid;
                }

                img {
                  page-break-inside:
                    avoid;
                }
              }

            </style>

          </head>

          <body>

            <!-- =====================
                 TOP BAR
            ===================== -->

            <div class="topbar">

              <button
                class="print-button"
                onclick="window.print()"
              >
                🖨 Print
              </button>

            </div>

            <!-- =====================
                 PAPER
            ===================== -->

            <div class="paper">

              <!-- HEADER -->

              <div class="header">

                <img
                  src="/static/logo140.png"
                  alt="Leon Gallery"
                  class="logo"
                />

                <div class="contact">

                  <p>
                    <b>
                      www.leon-gallery.com
                    </b>
                  </p>

                  <p>
                    info@leon-gallery.com
                  </p>

                  <p>
                    leongallerymakati@gmail.com
                  </p>

                </div>

              </div>

              <!-- TITLE -->

              <div
                class="document-title editable"
                contenteditable="true"
              >
                Receipt
              </div>

              <!-- INFO -->

              <div class="info">

                <div class="info-row">

                  <div class="info-label">
                    Name:
                  </div>

                  <div
                    class="info-value editable"
                    contenteditable="true"
                  >
                    ${escapeHtml(firstname)}
                  </div>

                </div>

                <div class="info-row">

                  <div class="info-label">
                    Date:
                  </div>

                  <div
                    class="info-value editable"
                    contenteditable="true"
                  >
                    ${escapeHtml(formattedDate)}
                  </div>

                </div>

              </div>

              <!-- RECEIPT TABLE -->

              <table class="receipt-table">

                <thead>

                  <tr>

                    <th class="artist-cell">
                      Artist
                    </th>

                    <th class="details-cell">
                      Details
                    </th>

                    <th class="amount-cell">
                      Amount
                    </th>

                  </tr>

                </thead>

                <tbody>

                  <tr>

                    <!-- ARTIST -->

                    <td
                      class="artist-cell editable"
                      contenteditable="true"
                    >
                      ${escapeHtml(artist)}
                    </td>

                    <!-- DETAILS -->

                    <td class="details-cell">

                      ${imageHtml}

                      <div
                        class="artwork-details editable"
                        contenteditable="true"
                      >

                        <div class="artwork-title">
                          ${escapeHtml(title)}
                        </div>

                        <div>
                          ${escapeHtml(size)}
                        </div>

                        <div>
                          ${escapeHtml(medium)}
                        </div>

                        <div>
                          ${escapeHtml(type)}
                        </div>

                        ${
                          year
                            ? `
                              <div>
                                ${escapeHtml(year)}
                              </div>
                            `
                            : ""
                        }

                      </div>

                    </td>

                    <!-- AMOUNT -->

                    <td
                      class="amount-cell"
                    >

                      <div
                        class="amount-section"
                      >

                        <span
                          class="subtotal-label"
                        >
                          Sub Total
                        </span>

                        <span
                          class="editable"
                          contenteditable="true"
                        >
                          ${formatMoney(amount)}
                        </span>

                      </div>

                    </td>

                  </tr>

                </tbody>

                <tfoot>

                  <!-- DISCOUNT -->

                  <tr>

                    <td
                      colspan="2"
                      class="summary-label"
                    >
                      Discount
                    </td>

                    <td
                      class="summary-value editable"
                      contenteditable="true"
                    >
                      ${formatMoney(discount)}
                    </td>

                  </tr>

                  <!-- TOTAL -->

                  <tr>

                    <td
                      colspan="2"
                      class="total-label"
                    >
                      Total
                    </td>

                    <td
                      class="total-value editable"
                      contenteditable="true"
                    >
                      ${formatMoney(finalAmount)}
                    </td>

                  </tr>

                </tfoot>

              </table>

              <!-- SIGNATURE -->

              <div
                class="signature-section"
              >

                <div class="signature">

                  <div
                    class="signature-space editable"
                    contenteditable="true"
                  ></div>

                  <div
                    class="signature-line editable"
                    contenteditable="true"
                  >
                    Authorized Signature
                  </div>

                </div>

              </div>

              <!-- ADDRESS -->

              <div class="address">

                <p>
                  G/F Eurovilla 1,
                  Rufino Corner Legazpi Streets,
                </p>

                <p>
                  Legazpi Village,
                  Makati City
                </p>

                <p>
                  Philippines
                </p>

                <p>
                  Tel no. (632) 856-2781
                </p>

              </div>

            </div>

          </body>

        </html>
      `);

      printWindow.document.close();
      printWindow.focus();

    } catch (error) {
      console.error(
        "Print preview error:",
        error
      );

      alert(
        "Failed to generate receipt preview."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={classes.root}>

      <Grid
        container
        spacing={3}
      >

        {/* =====================
            PHOTO
        ===================== */}

        <Grid
          item
          lg={4}
          md={5}
          xs={12}
        >

          <Card
            className={classes.card}
          >

            <Box
              className={
                classes.sectionHeader
              }
            >

              <Box
                display="flex"
                alignItems="center"
              >

                <Box
                  className={
                    classes.headerIcon
                  }
                >
                  <ImageIcon
                    fontSize="small"
                  />
                </Box>

                <Box>

                  <Typography
                    variant="h6"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Artwork Photo
                  </Typography>

                  <Typography
                    variant="body2"
                    className={
                      classes.sectionSubtitle
                    }
                  >
                    Upload the artwork
                    image for the receipt
                  </Typography>

                </Box>

              </Box>

            </Box>

            <Divider />

            <CardContent
              className={
                classes.content
              }
            >

              <Box
                className={
                  classes.photoCard
                }
              >

                {imageData ? (

                  <img
                    src={imageData}
                    alt="Artwork"
                    className={
                      classes.photo
                    }
                  />

                ) : (

                  <Box
                    className={
                      classes.emptyPhoto
                    }
                  >

                    <ImageIcon
                      className={
                        classes.emptyPhotoIcon
                      }
                    />

                    <Typography
                      variant="body2"
                    >
                      No artwork image
                    </Typography>

                    <Typography
                      variant="caption"
                      color="textSecondary"
                    >
                      Select a photo below
                    </Typography>

                  </Box>

                )}

              </Box>

              <TextField
                fullWidth
                margin="normal"
                type="file"
                label="Photo"
                variant="outlined"
                className={
                  classes.fileInput
                }
                onChange={
                  handleImageChange
                }
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  accept: "image/*",
                }}
              />

            </CardContent>

          </Card>

        </Grid>

        {/* =====================
            DETAILS
        ===================== */}

        <Grid
          item
          lg={8}
          md={7}
          xs={12}
        >

          <Card
            className={classes.card}
          >

            <Box
              className={
                classes.sectionHeader
              }
            >

              <Box
                display="flex"
                alignItems="center"
              >

                <Box
                  className={
                    classes.headerIcon
                  }
                >
                  <ReceiptIcon
                    fontSize="small"
                  />
                </Box>

                <Box>

                  <Typography
                    variant="h6"
                    className={
                      classes.sectionTitle
                    }
                  >
                    Receipt Details
                  </Typography>

                  <Typography
                    variant="body2"
                    className={
                      classes.sectionSubtitle
                    }
                  >
                    Enter the private sale
                    receipt information
                  </Typography>

                </Box>

              </Box>

            </Box>

            <Divider />

            <CardContent
              className={
                classes.content
              }
            >

              {/* NAME */}

              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                className={
                  classes.field
                }
                value={firstname}
                onChange={(e) =>
                  setFirstName(
                    e.target.value
                  )
                }
                placeholder={
                  "Enter customer name"
                }
              />

              {/* DATE */}

              <TextField
                fullWidth
                type="date"
                label="Date"
                variant="outlined"
                className={
                  classes.field
                }
                value={date}
                onChange={(e) =>
                  setDate(
                    e.target.value
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />

              {/* ARTIST */}

              <TextField
                fullWidth
                label="Artist"
                variant="outlined"
                className={
                  classes.field
                }
                value={artist}
                onChange={(e) =>
                  setArtist(
                    e.target.value
                  )
                }
                placeholder={
                  "Enter artist name"
                }
              />

              {/* TITLE */}

              <TextField
                fullWidth
                label="Title Name"
                variant="outlined"
                className={
                  classes.field
                }
                value={title}
                onChange={(e) =>
                  setTitle(
                    e.target.value
                  )
                }
                placeholder={
                  "Enter artwork title"
                }
              />

              {/* YEAR */}

              <TextField
                fullWidth
                label="Year"
                variant="outlined"
                className={
                  classes.field
                }
                value={year}
                onChange={(e) =>
                  setYear(
                    e.target.value
                  )
                }
                placeholder={
                  "Enter year"
                }
              />

              {/* MEDIUM */}

              <TextField
                fullWidth
                label="Medium"
                variant="outlined"
                className={
                  classes.field
                }
                value={medium}
                onChange={(e) =>
                  setMedium(
                    e.target.value
                  )
                }
                placeholder={
                  "Enter medium"
                }
              />

              {/* SIZE */}

              <TextField
                fullWidth
                label="Size"
                variant="outlined"
                className={
                  classes.field
                }
                value={size}
                onChange={(e) =>
                  setSize(
                    e.target.value
                  )
                }
                placeholder={
                  "Enter artwork size"
                }
              />

              {/* TYPE */}

              <TextField
                fullWidth
                label="Type"
                variant="outlined"
                className={
                  classes.field
                }
                value={type}
                onChange={(e) =>
                  setType(
                    e.target.value
                  )
                }
                placeholder={
                  "Private Sale"
                }
              />

              {/* DISCOUNT */}

              <TextField
                fullWidth
                type="number"
                label="Discount"
                variant="outlined"
                className={
                  classes.field
                }
                value={discount}
                onChange={(e) =>
                  setDiscount(
                    parseFloat(
                      e.target.value || 0
                    )
                  )
                }
                inputProps={{
                  min: 0,
                }}
              />

              {/* AMOUNT */}

              <TextField
                fullWidth
                type="number"
                label="Amount"
                variant="outlined"
                className={
                  classes.field
                }
                value={amount}
                onChange={(e) =>
                  setAmount(
                    parseFloat(
                      e.target.value || 0
                    )
                  )
                }
                inputProps={{
                  min: 0,
                }}
              />

              {/* SUMMARY */}

              <Box
                className={
                  classes.summaryBox
                }
              >

                <Typography
                  variant="body2"
                  className={
                    classes.summaryTitle
                  }
                >
                  Amount Summary
                </Typography>

                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Sub Total
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    {formatMoney(amount)}
                  </span>

                </Box>

                <Box
                  className={
                    classes.summaryRow
                  }
                >

                  <span
                    className={
                      classes.summaryLabel
                    }
                  >
                    Discount
                  </span>

                  <span
                    className={
                      classes.summaryValue
                    }
                  >
                    -
                    {formatMoney(
                      discount
                    )}
                  </span>

                </Box>

                <Box
                  className={
                    classes.totalRow
                  }
                >

                  <span
                    className={
                      classes.totalLabel
                    }
                  >
                    Total
                  </span>

                  <span
                    className={
                      classes.totalValue
                    }
                  >
                    {formatMoney(
                      parseFloat(
                        amount || 0
                      ) -
                      parseFloat(
                        discount || 0
                      )
                    )}
                  </span>

                </Box>

              </Box>

            </CardContent>

            <Divider />

            {/* =====================
                ACTION
            ===================== */}

            <Box
              className={
                classes.actionSection
              }
            >

              <Button
                variant="contained"
                color="primary"
                className={
                  classes.actionButton
                }
                startIcon={
                  <VisibilityIcon />
                }
                onClick={
                  generatePDF
                }
              >
                Preview & Print
              </Button>

            </Box>

          </Card>

        </Grid>

      </Grid>

      {/* =====================
          LOADING
      ===================== */}

      <Backdrop
        className={
          classes.backdrop
        }
        open={loading}
      >

        <CircularProgress
          color="inherit"
        />

      </Backdrop>

    </Box>
  );
};

export default Views;